import { render } from "./WorkHandle.vue?vue&type=template&id=4e1652f8"
import script from "./WorkHandle.vue?vue&type=script&lang=js"
export * from "./WorkHandle.vue?vue&type=script&lang=js"

import "./WorkHandle.vue?vue&type=style&index=0&id=4e1652f8&lang=less"

import exportComponent from "D:\\wwwroot\\tutoredin\\online-education\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__